import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import type { Experiments, IAppWillMountHandler, IHeadContent } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol, HeadContentSymbol, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { IMpaNavigation } from 'feature-mpa-navigation'
import { MpaNavigationSymbol } from 'feature-mpa-navigation'
import type { SpeculationRulesSiteConfig, SpeculationRulesConfig, SpeculationRule } from './types'
import { name } from './symbols'

/**
 * Adds speculation rules to the head when MPA navigation is eligible
 */
export const SpeculationRules = withDependencies(
	[named(SiteFeatureConfigSymbol, name), HeadContentSymbol, optional(MpaNavigationSymbol), ExperimentsSymbol],
	(
		siteFeatureConfig: SpeculationRulesSiteConfig,
		headContent: IHeadContent,
		mpaNavigation: IMpaNavigation | undefined,
		experiments: Experiments
	): IAppWillMountHandler => {
		return {
			async appWillMount() {
				// Check if MPA navigation is eligible
				const isMpaEligible = mpaNavigation?.isEligible() ?? false

				if (isMpaEligible) {
					const baseRule: SpeculationRule = {
						where: {
							and: [{ href_matches: '/*' }, { not: { href_matches: `${siteFeatureConfig.currentPagePath}` } }],
						},
						eagerness: 'moderate',
					}

					const speculationRulesConfig: SpeculationRulesConfig = {
						...(experiments['specs.thunderbolt.usePrerenderUntilScript']
							? {
									prerender_until_script: [{ tag: 'mpa-prerender-script-moderate', ...baseRule }],
								}
							: {}),
						prefetch: [{ tag: 'mpa-prefetch-moderate', ...baseRule }],
					}

					headContent.setHead(`<script type="speculationrules">${JSON.stringify(speculationRulesConfig)}</script>`)
				}
			},
		}
	}
)
